import { get, omit } from 'lodash-es';

class StichPPSI {
  constructor(ppsi, ppis) {
    this.ppsi = ppsi;
    this.ppis = ppis;
  }

  getPpiById(id) {
    return this.ppis.find(ppi => ppi.id === id);
  }

  stitchPpiDetails() {
    // Inject PPI
    return get(this.ppsi, 'ppiDetails', []).map(
      ({ itemCode, ppiEnrichmentDataId, amount, lineId }) => {
        const ppi = this.getPpiById(ppiEnrichmentDataId);
        const ingredient = { itemCode, amount, lineId };

        return {
          itemCode,
          ppi,
          ingredient
        };
      }
    );
  }

  stitchServingInstructions() {
    return get(this.ppsi, 'servingInstructions', []).map(servingInstruction => {
      const result = omit(servingInstruction, 'ppiEnrichmentId');
      const { ppiEnrichmentId } = servingInstruction;
      const ppi = this.getPpiById(ppiEnrichmentId);

      return {
        ...result,
        ppi
      };
    });
  }

  stitch() {
    const ppsi = this.ppsi;
    const ppiDetails = this.stitchPpiDetails();
    const servingInstructions = this.stitchServingInstructions();

    return {
      ...ppsi,
      ppiDetails,
      servingInstructions
    };
  }
}

export default function stichPpsi(ppsi, ppis) {
  return new StichPPSI(ppsi, ppis).stitch();
}
